import { PureComponent } from 'preact-compat'
import {
  getReply,
  markBestAnswer,
  unmarkBestAnswer
} from '../../services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'
import { Reply } from '../../interfaces'

export interface BestAnswerProps {
  replyId: string
  topicId: number
  contentType: ContentType
  isBestAnswer: boolean
  onBestAnswerChanged: (answerReply: Reply | null) => void
}

class BestAnswer extends PureComponent<BestAnswerProps> {
  constructor (props: BestAnswerProps) {
    super(props)
    this.markBestAnswer = this.markBestAnswer.bind(this)
  }

  async markBestAnswer () {
    const { replyId, topicId, contentType, isBestAnswer, onBestAnswerChanged } = this.props
    try {
      if (isBestAnswer) {
        await unmarkBestAnswer(contentType, replyId)
        onBestAnswerChanged(null)
      } else {
        await markBestAnswer(contentType, replyId)
        const answerReply = await getReply(contentType, topicId, Number(replyId))
        onBestAnswerChanged(answerReply)
      }
    } catch {}
  }

  render () {
    const { isBestAnswer } = this.props
    return (
      <div className='post--options-list-container-item'>
        <a data-qa='answer' className='post--options-icon' onClick={this.markBestAnswer}>
          <i className={`fa ${isBestAnswer ? 'fa-times' : 'fa-check'}`} />
          {isBestAnswer ? 'Unmark answer' : 'Best answer'}
        </a>
      </div>
    )
  }
}

export default BestAnswer
